import React from 'react';

const DateWidget = ({ settings, value, onChange }) => {
  const inputStyle = {
    padding: '8px 12px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    fontSize: '0.9rem',
    outline: 'none',
    width: '200px',
  };

  return (
    <input
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={inputStyle}
    />
  );
};

export default DateWidget;
